import React from "react";
import { Paper } from "@mui/material";

import {ANLoadingScreen } from "@answersnow/pkg-theme";
import { useGetClinicianNextAppointment } from "hooks/api/clinician/useGetClinicianNextAppointment";
import { ModuleContainer } from "../styles";
import NextAppointmentModule from "./NextAppointmentModule";

/** @typedef {import("api/typesDef").ClinicianBasicInfo} ClinicianBasicInfo */
/**
 * NextAppointment component
 * This component is used to display the next appointment for a clinician.
 *
 * @param {Object} props
 * @param {string|number} props.clinicianUserId - The clinician user id.
 * @param {ClinicianBasicInfo} props.clinicianInfo - The clinician info.
 * @param {boolean} props.isSmallScreen - Whether the screen is small.
 * @param {boolean} props.showLinkButton - Whether to show the link buttons.
 * @returns {JSX.Element} The NextAppointment component.
 */

const NextAppointment = ({ clinicianUserId, clinicianInfo, isSmallScreen, showLinkButton }) => {
  const { nextAppointment, nextAppointmentLoading } =
    useGetClinicianNextAppointment(clinicianUserId);

  if (nextAppointmentLoading) {
    return (
      <Paper component="section" elevation={2} sx={ModuleContainer}>
        <ANLoadingScreen height="100%" />
      </Paper>
    );
  }

  return (
    <NextAppointmentModule
      appointmentData={nextAppointment?.[0]}
      clinicianInfo={clinicianInfo}
      isSmallScreen={isSmallScreen}
      showLinkButton={showLinkButton}
    />
  );
};

export default NextAppointment;
